module.exports = __webpack_public_path__ + "img/camera.ab755d5a.svg";